<template>
   <div class="error-modal"  @click.esc="closeEmail">
     <div class="error-modal-body">
         <div class="error-img">
           <img src="@/assets/icon/error.png" alt="">
         </div>
        <div class="error-error"><p>{{errorMessage}}</p></div>
        <div class="error-close">
          <img src="@/assets/icon/close.png" alt="">
        </div>
     </div>
   </div>
</template>

<script>
export default {
          props:['errorMessage'],
          methods:{
            closeEmail(){
                this.$emit('hideEmailErrorMessage');
            },
        }
}
</script>
<style scoped>
.error-modal{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  display: flex;
  justify-content: center;
  z-index:2000;
}
.error-modal-body{
  position: absolute;
  top:30%;
  width: 465px;
  height: 120px;
  border-radius: 5px;
  border:1px solid #f8c3c5;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  background: #fffafa;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.error-modal-body .error-error{
  margin-top:37px!important;
  font-size:13px;
  width: 306px;
  padding-left:18px;
  line-height: 1.38;
  flex:5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin:0;
  text-align: left;
}
.error-modal-body div p{
  margin:0;
}
.error-modal-body .error-img{
  margin-top:37px!important;
  height: 49px;
  flex:0.5;
  padding-left:18px;
  line-height: 1.38;
}
.error-modal-body .error-close{
  width:auto;
  margin-top:21px!important;
  height: 49px;
  padding-right: 18px;
  color:#fff;
}
.error-modal-body img{
  width:100%;
  cursor: pointer;
}
.error-modal-body .error-message-icon{
  margin-top:37px;
  height: 49px;
  flex:0.8;
  font-size:38px;
  color:#fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}
.error-modal-body .error-message-btn{
  margin-top:25px;
  height: 49px;
  flex:0.8;
  font-size:18px;
  color:#fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
@media screen and (max-width: 500px) {
  .error-modal-body{
    margin-top:80%;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body{
    margin-top:60%;
    width:80%;
  }
}
</style>